import {useMediaQuery} from '@material-ui/core';

export const useWindowMedia = () => {
  const windowLargePlus = useMediaQuery('(min-width: 992px)');
  const windowMediumPlus = useMediaQuery('(min-width: 768px)');

  return {windowLargePlus, windowMediumPlus};
};
